export const isPersistedPath = (path: unknown): path is string =>
  typeof path === "string" && path.length > 0 && !path.startsWith("blob:");
